import RemoveCrossButton from './RemoveCrossButton';

export default RemoveCrossButton;